import { Component } from '@angular/core';
import { MunilyAreaPictureUploaderSize } from 'src/app/common-components/area-picture-uploader/area-picture-uploader.types';

@Component({
  selector: 'app-area-picture-uploader-playground',
  templateUrl: './area-picture-uploader-playground.component.html',
  styleUrls: ['./area-picture-uploader-playground.component.scss'],
})
export class AreaPictureUploaderPlaygroundComponent {
  imageUrl = '';
  size: MunilyAreaPictureUploaderSize = 'small';
  disabled = false;
  lastEvent = '';

  readonly sizes: MunilyAreaPictureUploaderSize[] = ['small', 'large'];

  onUpload(): void {
    this.lastEvent = `upload @ ${new Date().toLocaleTimeString()}`;
  }

  onRemove(): void {
    this.imageUrl = '';
    this.lastEvent = `remove @ ${new Date().toLocaleTimeString()}`;
  }
}
